import {UseMedia} from 'hooks/useMedia';
import {useState} from 'react';
import Container from 'react-bootstrap/Container';
import Footer from '../../components/Footer/footer.jsx';
// import './about.css';
import pattern from '../Home/pattern4.png';
import Markdown from 'markdown-to-jsx';

export default function GetStarted() {
  const [media, setMedia] = useState();
  UseMedia('min-width', 1000, setMedia);

  return (
    <div
      className="Whole_div rules"
      style={{backgroundImage: `url(${pattern})`}}
    >
      <Container fluid>
        <Markdown>{`
# Get started

This hackathon is using GitHub to manage the projects. If you are new to GitHub, please follow the steps below to get started.

1. Create a GitHub account

2. Go to https://classroom.github.com/a/KqhFdRnM to join the hackathon

3. Search and select your email address from the list

    - If you cannot find your email address, please chose _"Can't find your name, Skip to the next step"_.

4. Create or join a team

    - Only one team member needs to create a team

    - The others can join the team by searching the team name

5. Click on _Accept this assignment_ to join the hackathon

6. Navigate to the team repository link on GitHub.

    - It should look something like \`https://github.com/Hackathon-TW-2023/zebrahack1-0-YOUR_TEAM_NAME\`

7. Clone the repository to your local machine

# Happy Hacking :)`}</Markdown>
      </Container>
      <Footer />
    </div>
  );
}
